// extracted by mini-css-extract-plugin
export var active = "_96-7";
export var container = "_96-0";
export var evenWidth = "_96-4";
export var large = "_96-5";
export var outlet = "_96-8";
export var slide = "_96-2";
export var small = "_96-6";
export var tab = "_96-3";
export var tabs = "_96-1";